import '../ambient';

import { AdminApp } from '../components';
import { ClientApp } from './client-app';
import React from 'react';
import ReactDOM from 'react-dom';
import { Site } from '@cardsetter/site-sdk';
import { createAdminAppStore } from '../store';
import { createBrowserHistory } from 'history';
import { getApolloCache } from './get-apollo-cache';
import { getPreloadedState } from './get-preloaded-state';
import { loadableReady } from '@loadable/component';
import qs from 'qs';

if (window !== window.parent) {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  query.viewport = true;
  window.location.href = window.location.href =
    '/' + qs.stringify(query, { addQueryPrefix: true });
}

const history = createBrowserHistory();

const site = new Site({ cache: getApolloCache('admin'), uri: '/graphql' });

const store = createAdminAppStore({
  epicDependencies: { client: site.client, site },
  history,
  preloadedState: getPreloadedState('admin'),
});

window.addEventListener('dragover', e => e.preventDefault(), false);
window.addEventListener('drop', e => e.preventDefault(), false);

loadableReady((): void => {
  ReactDOM.hydrate(
    <ClientApp client={site.client} history={history} store={store}>
      <AdminApp />
    </ClientApp>,
    document.getElementById('root'),
  );
});
